import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const SEO = ({ title, description, keywords, ogTitle, ogSiteName }) => {
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    {title && <title>{title}</title>}
                    {description && <meta name="description" content={description} />}
                    {keywords && <meta name="keywords" content={keywords} />}
                    {ogTitle && <meta property="og:title" content={ogTitle} />}
                    {ogSiteName && <meta property="og:site_name" content={ogSiteName} />}
                </Helmet>
            </HelmetProvider>
        </>
    )
}
export default SEO



// WEBPACK FOOTER //
// ./src/estimate_list/libs/seo.js